import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import ContactUsForm from "components/forms/SimpleContactUs.js";
import ContactDetails from "components/cards/OneColContactDetails.js";

import { MapContainer } from "components/cards/MapComponent";

const Address = tw.span`leading-relaxed`;
const AddressLine = tw.span`block`;
const Email = tw.span`text-sm mt-6 block text-gray-500`;
const Phone = tw.span`text-sm mt-0 block text-gray-500`;

export default () =>  {
    return (
      <AnimationRevealPage>
      <Header />
      <ContactUsForm />
      <ContactDetails
        cards={[
          {
            title: "New York",
            description: (
              <>
                <Address>
                  <AddressLine>1961 Richmond Terrace</AddressLine>
                  <AddressLine>Staten Island, Ny 10302</AddressLine>
                </Address>
                <Email><a href="mailto:sales@mhtlighting.com">sales@mhtlighting.com</a></Email>
                <Phone><a href="tel:718-524-4370">+1 (718)-524-4370</a></Phone>
              </>
            )
          },
          {
            title: "",
            description: (
              <>
                < MapContainer />
              </>
            )
          }
        ]}
      />
      <Footer />
      
    </AnimationRevealPage>
    );
  
}

